const buildPath = (...args) => args.join("/").trim();

export default buildPath;
